import { gql, useQuery } from '@apollo/client';

import { GraphQLTypes } from 'src/lib/graphqlTypes';

export const useCloudRouterStatusQuery = (
  serviceId: string,
  graphVariant: string,
  skip: boolean,
) => {
  return useQuery<
    GraphQLTypes.CloudRouterStatusQuery,
    GraphQLTypes.CloudRouterStatusQueryVariables
  >(
    gql`
      query CloudRouterStatusQuery($serviceId: ID!, $graphVariant: String!) {
        service(id: $serviceId) {
          id
          variant(name: $graphVariant) {
            id
            router {
              id
              status
            }
          }
        }
      }
    `,
    {
      variables: {
        serviceId,
        graphVariant,
      },
      skip,
      pollInterval: 3000,
    },
  );
};
